export function formatCurrency(value) {
  if (!value) return '$0.00';
  return parseFloat(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}
